import { Skeleton } from '../ui/skeleton';

const StatisticsCardSkeleton = () => (
    <div className="border border-neutral-300 rounded-lg p-4 animate-pulse">
        <div className="flex justify-between items-center mb-3">
            <Skeleton className="h-4 bg-neutral-200 rounded w-32 max-w-full" />
            <Skeleton className="h-5 w-5 bg-neutral-200 rounded max-w-full" />
        </div>
        <Skeleton className="h-10 bg-neutral-200 rounded w-16 mb-2 max-w-full" />
        <Skeleton className="h-4 bg-neutral-200 rounded w-40 max-w-full" />
    </div>
);

export default StatisticsCardSkeleton;
